import { render, staticRenderFns } from "./HGroup.vue?vue&type=template&id=0acaa512&"
import script from "./HGroup.vue?vue&type=script&lang=js&"
export * from "./HGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports